var searchData = angular.module('searchData', ['configService']);

searchData.factory('getSearchInfo', function($http, config) {
    var searchInfo = function(queryString, token) {
        return $http.get(config.domain + '/api/v1/search?version=1.2&q=' + encodeURIComponent(queryString) + '&suggest=true&token=' + token);
    }
    //console.log("searchInfo",searchInfo);
    return searchInfo;
});

searchData.factory('getSearchSuggest', function($http, config) {
    var searchSuggest = function(queryString, searchType, token) {
        return $http.get(config.domain + '/api/v1/suggest?limit=10&token=' + token + '&suggest_type=' + searchType + '&suggest_prefix=' + encodeURIComponent(queryString));
    }
    return searchSuggest;
});

searchData.factory('getPopularSearches', function($http, config) {
    var popularSearches = function(searchType, token) {
        return $http.get(config.domain + '/api/v1/popular?token=' + token + '&suggest_type=' + searchType);
    }
    return popularSearches;
});

searchData.factory('getVendorInfo', function($http, config) {

    var vendorInfo = function(token, queryString, type) {
        //console.log("shi token",token,config);
        //console.log("type",type,type == undefined,queryString);
        return type == undefined ? $http.get('/api/v1/search?version=1.2&q=' + queryString + '&suggest=false&token=' + 881276) : $http.get(config.domain + '/api/v1/search?version=1.2&q=' + queryString + '&suggest=false&web=true&token=' + token + '&type=' + type);
    }
    return vendorInfo;
});

searchData.factory('getSearchFeed', function($http, $timeout, config) {
    var getSearchFeed = function(token, queryString, type) {
        this.items = [];
        this.busy = false;
        this.after = '';
        this.token = token;
        this.queryString = queryString;
        this.type = type;
        this.offset = 0;
        this.noData = false;
        this.token = token;
        this.flag = 0;
    };

    getSearchFeed.prototype.nextPage = function() {
        if (this.busy) return;
        this.busy = true;
        //var url = "http://api.reddit.com/hot?after=" + this.after + "&jsonp=JSON_CALLBACK";
        var url = config.domain + '/api/v1/search?version=1.2&q=' + encodeURIComponent(this.queryString) + '&suggest=false&web=true&token=' + this.token + '&type=' + this.type + '&offset=' + this.offset + '&limit=30';
        $http.get(url).success(function(data) {
            if (data.data) {
                if (window.location.pathname.split('/')[2] == 'photos') {

                    data.data.forEach(function(obj) {
                        var desc = obj._source,
                            width = desc.image_width,
                            height = desc.image_height;
                        imageUrl = desc.image_url ? desc.image_url.replace('%%', '400') : desc.image_url;
                        obj.actualHeight = height;
                        obj.actualWidth = width;
                        obj.actualImageUrl = imageUrl;
                    });
                }
                var items = data.data;
                for (var i = 0; i < items.length; i++) {
                    this.items.push(items[i]);
                }
                //this.feed = false
                this.offset = this.offset + 30;
                this.busy = false;
                this.noData = false;
                // if (items.length < 30) {
                //     this.noData = true;
                // }
                this.flag = 1;
                $timeout(function() {
                  if (window.location.href.indexOf('admin') == -1) {
                    $('img').bind('contextmenu', function(e) {
                        return false;
                    });
                  }
                },1000)
            } else {
                this.noData = true;
                //this.busy = "Oops NO Data Found";
            }
        }.bind(this));
    };
    return getSearchFeed;
});

sharedServices.factory('imageDetail', function($http, config) {
    var imageDetail = function(imageId, token) {
        return $http.get(config.domain + '/api/v1/gallery/image/' + imageId + '?version=1.1&token=' + token);
    }
    return imageDetail;
});

sharedServices.factory('getPhotosFeed', function($http, config) {
    var getPhotosFeed = function(token, randomNumber, category, city, color) {
        category = (category == '' || category == undefined) ? 'all' : category;
        city = (city == '' || city == undefined) ? 'all' : city;
        color = (color == '' || color == undefined) ? 'all' : color;
        return $http.get(config.domain + '/api/v1/gallery?version=1.3&token=' + token + '&random=' + randomNumber + '&filter=1&seo=1&offset=0&limit=10&category_slug=' + category + '&city_slug=' + city + '&color_slug=' + color);
    }
    return getPhotosFeed;
});

sharedServices.factory('getPhotosFeedImage', function($http, $timeout, config) {
    var getPhotosFeedImage = function(token, randomNumber) {
        this.items = [];
        this.busy = false;
        this.after = '';
        this.token = token;
        this.randomNumber = randomNumber;
        this.offset = 0;
        this.noData = false;
        this.limit = 100;
        this.token = token;
        this.flag = 0;
		this.parsed_count = '';
    }
    getPhotosFeedImage.prototype.nextPage = function() {
        if (this.busy) return;
        this.busy = true;
        if (this.offset > 0) {
            //window.parsePins();
            setTimeout(function() {
                window.parsePins();
            }, 1000);
        }
        this.parsed_count = '';
        var url = config.domain + '/api/v1/gallery?version=1.3&token=' + this.token + '&random=' + this.randomNumber + '&offset=' + this.offset + '&limit=' + this.limit;
        $http.get(url).success(function(data) {
            if (data.data) {
                data.data.forEach(function(obj) {
                    var desc = obj,
                        width = desc.image_width,
                        height = desc.image_height;
                    imageUrl = desc.image_url ? desc.image_url.replace('%%', '400') : desc.image_url;
                    obj.actualHeight = height;
                    obj.actualWidth = width;
                    obj.actualImageUrl = imageUrl;
                    if (((/Android/i.test(navigator.userAgent)) && (!/Mobile/i.test(navigator.userAgent))) || (/iPad/i.test(navigator.userAgent))) {
                        obj.isTab = 1;
                    } else {
                        obj.isTab = 0;
                    }
                });
                var items = data.data;
                for (var i = 0; i < items.length; i++) {
                    this.items.push(items[i]);
                }
                //this.feed = false
                this.limit = 30;
                if (this.offset >= 100) {
                    this.offset = this.offset + 30;
                } else {
                    this.offset = this.offset + 100;
                }
                this.busy = false;
                this.noData = false;
                this.flag = 1;
                $timeout(function() {
                    if (data.data.length == 1) {
                        $('.deckgrid').find('.column').removeClass('column-1-4');
                    } else {
                        $('.deckgrid').find('.column').addClass('column-1-4');
                    }
                    if (window.location.href.indexOf('admin') == -1) {
                        $('img').bind('contextmenu', function(e) {
                            return false;
                        });
                    }
                }, 500)
            } else {
                this.noData = true;
                //this.busy = "Oops NO Data Found";
            }
			if(data.parsed_count){
				this.parsed_count = data.parsed_count;
			}
        }.bind(this));
    };
    return getPhotosFeedImage;
});

sharedServices.factory('getPhotosFeedImageFilter', function($http, $timeout, config) {
    var getPhotosFeedImageFilter = function(token, randomNumber, category, city, color, keyword) {
        this.items = [];
        this.popular_tags = [];
        this.parsed_count = '';
        this.busy = false;
        this.after = '';
        this.token = token;
        this.randomNumber = randomNumber;
        this.limit = 100;
        this.offset = 0;
        this.noData = false;
        this.token = token;
        this.flag = 0;
        this.category = category;
        this.city = city;
        this.color = color;
        this.keyword = keyword;
    }
    getPhotosFeedImageFilter.prototype.nextPage = function(keyword) {
        if (this.busy) return;
        if(this.noData) return;
        this.busy = true;
        if (!(this.category) && !(this.color) && this.city) {
            var url = config.domain + '/api/v1/gallery?version=1.3&token=' + this.token + '&random=' + this.randomNumber + '&offset=' + this.offset + '&limit=' + this.limit + '&city_slug=' + this.city + '&keyword=' + this.keyword;
        } else if ((this.category) && !(this.color) && (this.city)) {
            var url = config.domain + '/api/v1/gallery?version=1.3&token=' + this.token + '&random=' + this.randomNumber + '&offset=' + this.offset + '&limit=' + this.limit + '&category_slug=' + this.category + '&city_slug=' + this.city + '&keyword=' + this.keyword;
        } else {
            var url = config.domain + '/api/v1/gallery?version=1.3&token=' + this.token + '&random=' + this.randomNumber + '&offset=' + this.offset + '&limit=' + this.limit + '&category_slug=' + this.category + '&city_slug=' + this.city + '&color_slug=' + this.color + '&keyword=' + this.keyword;
        }
        this.parsed_count = '';
        $http.get(url).success(function(data) {
            if (data.data.length != 0) {
                data.data.forEach(function(obj) {
                    var desc = obj,
                        width = desc.image_width,
                        height = desc.image_height;
                    imageUrl = desc.image_url ? desc.image_url.replace('%%', '400') : desc.image_url;
                    obj.actualHeight = height;
                    obj.actualWidth = width;
                    obj.actualImageUrl = imageUrl;
                    if (((/Android/i.test(navigator.userAgent)) && (!/Mobile/i.test(navigator.userAgent))) || (/iPad/i.test(navigator.userAgent))) {
                        obj.isTab = 1;
                    } else {
                        obj.isTab = 0;
                    }
                });
                var items = data.data;
                for (var i = 0; i < items.length; i++) {
                    this.items.push(items[i]);
                }
                //this.feed = false
                this.limit = 30;
                if (this.offset >= 100) {
                    this.offset = this.offset + 30;
                } else {
                    this.offset = this.offset + 100;
                }
                this.busy = false;
                this.noData = false;
                this.flag = 1;
                $timeout(function() {
                    if (data.data.length == 1) {
                        $('.deckgrid').find('.column').removeClass('column-1-4');
                    } else {
                        $('.deckgrid').find('.column').addClass('column-1-4');
                    }
                }, 500)
            } else {
                this.noData = true;
                //this.busy = "Oops NO Data Found";
            }

			if(data.parsed_count){
				this.parsed_count = data.parsed_count;
			}

            if (data.popular_tags) {
                this.popular_tags = data.popular_tags
            };
        }.bind(this));
    };
    return getPhotosFeedImageFilter;
});

sharedServices.factory('imageShare', function($http, config) {
    var imageShare = function(content_id, token, content_type) {
        return $http({
            method: 'post',
            url: config.domain + '/api/v1/share?version=1.1&token=' + token,
            data: {
                'content_id': content_id,
                'content_type': content_type,
            }
        })
    }
    return imageShare;
});

/*searchData.service('imageService',['$q','$http', 'config',function($q, $http, config){
	this.loadImages = function(token, queryString, type){
	   return type == undefined ? $http.get(config.domain + '/api/v1/search?version=1.2&q='+queryString+'&suggest=false&token=' + token) : $http.get(config.domain + '/api/v1/search?version=1.2&q='+queryString+'&suggest=false&web=true&token=' + token + '&type=' + type+'&offset=0&limit=9');
	};
}])*/
